import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';

export const useDeleteContact = (clientId: number, contactId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetchJson(`/clients/${clientId}/contacts/${contactId}`, {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.quotations.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoiceTemplates.root });

      return queryClient.invalidateQueries({ queryKey: QueryKeys.clients.index });
    },
  });
};
